import { render, staticRenderFns } from "./Truth.vue?vue&type=template&id=4fc362e4&scoped=true&"
import script from "./Truth.vue?vue&type=script&lang=js&"
export * from "./Truth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc362e4",
  null
  
)

export default component.exports